






























































































































import PartnerReportDetailSendToKsrDialogKsrDetail from "@/components/partner/PartnerReportDetailSendToKsrDialogKsrDetail.vue";
import CustomFieldListForm from "@/components/report/CustomFieldListForm.vue";
import ConfirmActionDialog from "@/components/utility/ConfirmActionDialog.vue";
import Debug from "@/components/utility/Debug.vue";
import MActionList from "@/components/utility/mmmint/MActionList.vue";
import MDetailTable, {
  DetailTableTypeEnum,
  DetailTableVisualizationEnum,
  IMDetailTableConfig
} from "@/components/utility/mmmint/MDetailTable.vue";
import MDetailViewGrid from "@/components/utility/mmmint/MDetailViewGrid.vue";
import MHeader, { IAction } from "@/components/utility/mmmint/MHeader.vue";
import MoneyInput from "@/components/utility/MoneyInput.vue";
import RefsSelect from "@/components/utility/RefsSelect.vue";
import RefsSelected from "@/components/utility/RefsSelected.vue";
import { TpsEnum } from "@/lib/enum/third-party-system-type.enum";
import { IBreadcrumb } from "@/lib/interfaces/utility/breadcrumb-interface";
import { handleError } from "@/lib/utility/handleError";
import { $t } from "@/lib/utility/t";
import { ThirdPartySystemGoToHelper } from "@/lib/utility/third-party-system.go-to-helper";
import { Operation } from "@/models/operation.entity";
import { PageFilterElement } from "@/models/page-filter-element.entity";
import { IReference, Reference } from "@/models/reference.entity";
import { IThirdPartySystem } from "@/models/third-party-system.entity";
import { BackendResourceEnum } from "@/store/enum/authResourceEnum";
import { DaWebhookModule } from "@/store/modules/da-webhook.store";
import { ExportModule } from "@/store/modules/export.store";
import { OperationModule } from "@/store/modules/operation.store";
import { PartnerModule } from "@/store/modules/partner";
import { dossierTableConfig } from "@/views/portal/PartnerDaTableView.vue";
import { mixins } from "vue-class-component";
import { Component, Prop, Vue } from "vue-property-decorator";
import OperationTable from "../operations/OperationTable.vue";
import ActivityCard from "../thg/ActivityCard.vue";
import { SettingModule } from "@/store/modules/setting.store";
import { DaSettingsKeys } from "@/store/enum/manage/da-setting-keys.enum";
import { MrfiktivDaWebhookViewModelGen } from "@/services/mrfiktiv/v1/data-contracts";

@Component({
  components: {
    MHeader,
    MDetailViewGrid,
    ActivityCard,
    RefsSelect,
    CustomFieldListForm,
    MActionList,
    ConfirmActionDialog,
    MoneyInput,
    OperationTable,
    RefsSelected,
    MDetailTable,
    Debug,
    PartnerReportDetailSendToKsrDialogKsrDetail
  }
})
export default class ThirdPartySystemCard extends mixins(Vue) {
  readonly BackendResourceEnum = BackendResourceEnum;
  selected: string[] = [];

  @Prop()
  value!: IThirdPartySystem;

  @Prop()
  hideBreadCrumbs!: boolean;

  @Prop()
  showDetailButton!: boolean;

  isDeleteDialogActive = false;

  isLoadingDelete = false;

  isLoadingRefsUpdate = false;

  isExportSignDialogActive = false;

  isExportSignLoading = false;

  tab = 0;

  get signIds() {
    const uniqueSignIds: IReference[] = [];

    for (const ref of this.value.refs) {
      if (ref.refType === BackendResourceEnum.SIGN && !uniqueSignIds.find(r => r.refId === ref.refId)) {
        uniqueSignIds.push(ref);
      }
    }

    return uniqueSignIds;
  }

  get daDossier() {
    if (this.value.externalId === `${DaWebhookModule.dossier?.data?.dossier.id}`) {
      return DaWebhookModule.dossier;
    }

    return undefined;
  }

  get ksrJob() {
    if (this.value.externalId === `${ExportModule.ksrDocument?.jobId}`) {
      return ExportModule.ksrDocument;
    }

    return undefined;
  }

  get daDetailTable(): IMDetailTableConfig[] {
    const config = dossierTableConfig;

    return config;
  }

  get daDossierExtended() {
    if (!this.daDossier) {
      return [];
    }

    return [
      {
        key: "KSR",
        value: this.daDossier.ksrIds?.join(", ")
      },
      {
        key: "Status",
        value: this.stateName(this.daDossier)
      },
      {
        key: "Internal Status",
        value: this.internalStateName(this.daDossier)
      }
    ];
  }

  get isDa() {
    return this.value.system === TpsEnum.DA;
  }

  get isKsr() {
    return this.value.system === TpsEnum.KSR;
  }

  get title() {
    return this.value.system + " - " + this.value.externalId;
  }

  get partner() {
    return PartnerModule.partner;
  }

  get partnerId(): string {
    return this.$route.params.partnerId;
  }

  get breadCrumbs(): IBreadcrumb[] | undefined {
    if (this.hideBreadCrumbs) {
      return undefined;
    }

    const crumbs: IBreadcrumb[] = [];

    crumbs.push({
      exact: true,
      text: $t("thirdPartySystem.thirdPartySystems"),
      to: ThirdPartySystemGoToHelper.locations.thirdPartySystemTable({ partnerId: this.partnerId })
    });

    crumbs.push({
      exact: true,
      text: this.title,
      to: ThirdPartySystemGoToHelper.locations.thirdPartySystemDetail({
        partnerId: this.partnerId,
        thirdPartySystemId: this.value.id
      })
    });

    return crumbs;
  }

  get actions(): IAction[] | undefined {
    const actions: IAction[] = [];

    if (this.showDetailButton) {
      actions.push({
        key: "detail",
        text: $t("common.nouns.detail"),
        icon: "mdi-open-in-new",
        exec: () => this.value.goToDetail(this.$router, false)
      });
    }

    if (this.isKsr) {
      if (this.value.refs.find(r => r.refType === BackendResourceEnum.SIGN)) {
        actions.push({
          key: "ExportSign",
          text: $t("thirdPartySystem.exportSign"),
          icon: "mdi-file-send-outline",
          exec: () => (this.isExportSignDialogActive = true)
        });
      }
    }
    if (this.isDa) {
      if (this.value.refs.find(r => r.refType === BackendResourceEnum.SIGN)) {
        actions.push({
          key: "ExportSign",
          text: $t("thirdPartySystem.exportSign"),
          icon: "mdi-file-send-outline",
          exec: () => (this.isExportSignDialogActive = true)
        });
      }

      if (this.daLink) {
        actions.push({
          key: "open",
          text: $t("open"),
          icon: "mdi-share-outline",
          exec: () => {
            if (this.daLink) {
              window.open(this.daLink, "_blank", "noopener");
            }
          }
        });
      }
    }

    return actions;
  }

  get source(): IReference {
    return new Reference({
      refId: this.value.id,
      refType: BackendResourceEnum.TPS
    });
  }

  get daLink() {
    if (!this.daGroup || !this.daCenter || !this.daView || !this.value.externalId) {
      return undefined;
    }

    return `https://werkstattplanung.net/${this.daGroup}/${this.daCenter}/kic/da/index.html#/views/${this.daView}?caseId=${this.value.externalId}`;
  }

  get daGroup() {
    return SettingModule.allPartnerSettings.find(s => s.key === DaSettingsKeys.GROUP)?.value;
  }
  get daCenter() {
    return SettingModule.allPartnerSettings.find(s => s.key === DaSettingsKeys.CENTER)?.value;
  }
  get daView() {
    return SettingModule.allPartnerSettings.find(s => s.key === DaSettingsKeys.DOSSIER_VIEW_ID)?.value;
  }

  beforeMount() {
    OperationModule.setHiddenFilters([
      new PageFilterElement({
        value: this.value.id,
        operation: "$eq",
        key: "refs.refId"
      })
    ]);
  }

  beforeDestroy() {
    OperationModule.setHiddenFilters([]);
  }

  onDelete() {
    this.isLoadingDelete = true;
    this.value.delete().catch(handleError);
    this.isDeleteDialogActive = false;
    this.isLoadingDelete = false;
  }

  async updateRefs() {
    this.isLoadingRefsUpdate = true;
    await this.value.update().catch(handleError);
    this.isLoadingRefsUpdate = false;
  }

  async exportSigns() {
    this.isExportSignLoading = true;
    await Promise.all(
      this.selected.map(async signRequestId => {
        await this.exportSignRequest(signRequestId);
      })
    );
    this.isExportSignLoading = false;
  }

  async exportSignRequest(signRequestId: string) {
    try {
      const operation = await this.value.exportSignRequest(signRequestId);
      if (operation) {
        new Operation({ partnerId: this.partnerId, id: operation.operationId }).fetch();
        OperationModule.dispatchToast({ operationId: operation.operationId, partnerId: this.partnerId });
      }
      this.isExportSignDialogActive = false;
    } catch (e) {
      handleError(e);
    }
  }

  get publicStatus() {
    return Number(
      SettingModule.allPartnerSettings.find(s => s.key === DaSettingsKeys.CUSTOMER_STATUS_CATEGORY_ID)?.value
    );
  }

  get internalStatus() {
    return Number(
      SettingModule.allPartnerSettings.find(s => s.key === DaSettingsKeys.INTERNAL_STATUS_CATEGORY_ID)?.value
    );
  }

  stateName(item?: MrfiktivDaWebhookViewModelGen): string {
    return item?.data?.dossier?.states?.find(s => s.category_id === this.publicStatus)?.name ?? "";
  }

  internalStateName(item?: MrfiktivDaWebhookViewModelGen): string {
    return item?.data?.dossier?.states?.find(s => s.category_id === this.internalStatus)?.name ?? "";
  }
}
